import { render, staticRenderFns } from "./ItemPrimaVacacional.vue?vue&type=template&id=7dabed20&"
import script from "./ItemPrimaVacacional.vue?vue&type=script&lang=js&"
export * from "./ItemPrimaVacacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports